import React from 'react';
import { observer } from 'mobx-react';

import Styled from 'styled';
import computed from 'lib/mobx/computed';

import UserAvatarView, { UserAvatarViewModel } from 'four-nets/user/user-avatar/user-avatar-view';
import { HideForUnpaidVendor } from 'four-nets/vendor/permissions';

import defaultStyles from './new-comment-view.scss';

export class NewCommentViewModel {
    userAvatarViewModel: UserAvatarViewModel;

    constructor(options) {
        const { user } = options;
        this.userAvatarViewModel = new UserAvatarViewModel({ user });
    }

    @computed get title(): string {
        return 'Pridaj tvoj príspevok';
    }
}

@Styled(defaultStyles)
@observer
class NewCommentView extends React.Component {
    render() {
        const { newCommentViewModel, styles } = this.props;
        const { title } = newCommentViewModel;

        return (
            <HideForUnpaidVendor grey={true}>
                <div className={styles.newComment}>
                    <h2 className={styles.heading}>{this.props.title || title}</h2>
                    <div className={styles.userWrapper}>
                        <UserAvatarView userAvatarViewModel={newCommentViewModel.userAvatarViewModel} />
                        <div className={styles.background}>
                            <div className={styles.square} />
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </HideForUnpaidVendor>
        );
    }
}

export default NewCommentView;
